import React from "react";
import InvoiceHeader from "./InvoiceHeader";
import InvoiceTable from "./InvoiceTable";
import { InvoiceTotals, InvoiceBankSignature } from "./InvoiceFooter";

const OneInvoice = ({ data }) => {
  if (!data || data.length === 0) return null;
  const header = data.find(d => d.additional_charges && d.additional_charges !== "[]") || data[0];
  const sortedData = [...data].sort((a, b) => new Date(a.date) - new Date(b.date));
  const MAX_ITEMS_PAGE_1 = 33, MAX_ITEMS_PAGE_NEXT = 44, SAFE_LIMIT_FOOTER = 10;
  const dynamicChunks = [];
  let dataIndex = 0, isFirstPage = true;
  while (dataIndex < sortedData.length) {
    const maxAllowed = isFirstPage ? MAX_ITEMS_PAGE_1 : MAX_ITEMS_PAGE_NEXT;
    const remaining = sortedData.length - dataIndex;
    if (remaining <= maxAllowed) {
      if (remaining > (maxAllowed - SAFE_LIMIT_FOOTER)) { dynamicChunks.push(sortedData.slice(dataIndex, dataIndex + remaining)); dynamicChunks.push([]); }
      else { dynamicChunks.push(sortedData.slice(dataIndex, dataIndex + remaining)); }
      break;
    } else { dynamicChunks.push(sortedData.slice(dataIndex, dataIndex + maxAllowed)); dataIndex += maxAllowed; }
    isFirstPage = false;
  }
  const totalPages = dynamicChunks.length;
  return (
    <div style={{ fontFamily: 'Arial, Helvetica, sans-serif' }}>
      {dynamicChunks.map((chunk, index) => {
        const pageNum = index + 1;
        const isLastPage = pageNum === totalPages;
        const headerWithPage = { ...header, page_info: `PAGE ${pageNum} OF ${totalPages}` };
        let rollingStartIndex = 0;
        for (let i = 0; i < index; i++) rollingStartIndex += dynamicChunks[i].length;
        return (
          <div key={pageNum} className="print-page bg-white flex flex-col w-full box-border relative shadow-lg mx-auto" style={{ height: '296mm', width: '210mm', padding: '10mm 15mm' }}>
            <div className="absolute inset-0 flex items-center justify-center opacity-10 pointer-events-none z-10">
              <span className="text-8xl font-black text-blue-700 border-8 border-blue-700 p-8 transform -rotate-45 tracking-widest">DRAFT</span>
            </div>
            <div className="relative z-20 flex flex-col h-full">
              <InvoiceHeader header={headerWithPage} />
              {chunk.length > 0 ? (
                <div className="mt-4">
                  <InvoiceTable data={chunk} startIndex={rollingStartIndex} />
                  {isLastPage && <div className="mt-2"><InvoiceTotals data={sortedData} header={header} /></div>}
                  {!isLastPage && <div className="text-center text-xs font-bold text-gray-400 italic mt-4 border-t border-dashed pt-2">--- Continued on next page ---</div>}
                </div>
              ) : (
                <div className="mt-4">
                  <div className="font-bold text-lg border-b-2 border-black pb-1 mb-4 italic text-gray-500">Invoice Continuation Summary</div>
                  <InvoiceTotals data={sortedData} header={header} />
                </div>
              )}
              {isLastPage && <div className="mt-auto pb-4"><InvoiceBankSignature /></div>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const DraftInvoicePreview = ({ groups }) => {
  if (!groups || groups.length === 0) return <div className="p-8 text-center text-gray-500">Tidak ada data preview.</div>;
  return (
    <div className="space-y-8">
      {groups.map((g, i) => <OneInvoice key={i} data={g} />)}
    </div>
  );
};

export default DraftInvoicePreview;
